// Module
var code = "<template> <h1>Login</h1> <button click.delegate=\"redirectToLogin()\">Login</button> </template> ";
// Exports
export default code;